import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {stringUtils} from 'front-onceforall-core';

function MessageAutoTieView(props) {
  if (!props.domainName) {
    return null;
  }

  return (
    <>
      {stringUtils.getStrongs(I18n.t('user.domainNameAutomaticTieUser', {domainName: props.domainName}))}
    </>
  );
}

MessageAutoTieView.propTypes = {
  domainName: PropTypes.string
};

export default MessageAutoTieView;
